// eslint-disable-next-line import/prefer-default-export
export const DATETIME_FORMAT = 'DD.MM.YYYY HH:mm';
